<ui-wrapper>
  @if (navigation$ | async; as navigation) { @if (navigation.length > 0) {
  <p-menubar styleClass="app-nav-bar" [model]="navigation"> </p-menubar>
  } }
</ui-wrapper>
